export default __webpack_public_path__ + "static/Geologica-Light-71b0bbdfd258cfeb1e1ecc6d80b1794c.woff2";